import { clientFeedback } from '../components/client-feedback.js';

clientFeedback();